export enum NotificationType {
  Email,
  Sms,
  Push,
  EndPoint,
}
